import { GetWishlistDto } from '../../../dto/wishlist/getwishlist/getwishlistdto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface GetWishlistRequest extends APIRequest
{
    getGetWishlistRequest(): GetWishlistDto;
}

export class GetWishlistRequestImpl extends APIRequestDtoImpl implements GetWishlistRequest
{
    constructor(private getWishlistData: GetWishlistDto)
    {
        super();
    }

    getGetWishlistRequest(): GetWishlistDto
    {
        return this.getWishlistData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/wishlist/getwishlist/getwishlistrequest.tsx